import {
  DATA_LAYER_TYPE_PAYWALL__NONE,
  DATA_LAYER_TYPE_SECTION__FORECASTS,
  DATA_LAYER_TYPE_UID_PREFIX_FORECASTS,
  DATA_LAYER_TYPE_ACCESS_TYPE__PUB,
  DataLayerProps,
  getWordCount,
} from '@emarketer/datalayer';

export interface GetDataLayerPropsArgs {
  collection: any;
  propsCollectionId: number;
  template: any;
  userSubscriptionTier: string;
}

/**
 *
 * @param collection
 * @param propsCollectionId
 * @param template
 * @param userSubscriptionTier
 * @returns
 */
export const getDataLayerPropsForIndividualForecast = ({
  collection,
  propsCollectionId,
  template,
  userSubscriptionTier,
}: GetDataLayerPropsArgs): DataLayerProps => {
  const unifiedTemplateSuffix = template?.id ? `-${template.id}` : '';

  const dataLayerDetails: DataLayerProps = {
    unifiedAssetId: `${DATA_LAYER_TYPE_UID_PREFIX_FORECASTS}${
      collection?.id || propsCollectionId
    }${unifiedTemplateSuffix}`,
    accessType: DATA_LAYER_TYPE_ACCESS_TYPE__PUB,
    isAdBlock: false,
    isLocked: true,
    paywallType: DATA_LAYER_TYPE_PAYWALL__NONE,
    section: DATA_LAYER_TYPE_SECTION__FORECASTS,
    datePublishedUtc: template?.publicationDate,
    dateModifiedUtc: template?.lastModifiedTimestamp,
    topics: template?.topics?.join(','),
    // use words from each of these 3 properties to calculate count. if blank it'll be filtered out
    wordCount: getWordCount([template?.source, template?.note, template?.methodology].filter((v) => !!v).join(' ')),
    userSubscriptionTier,
  };

  return dataLayerDetails;
};

export const getDataLayerPropsForIndexPage = (userSubscriptionTier: string): DataLayerProps => {
  const dataLayerProps: DataLayerProps = {
    unifiedAssetId: `${DATA_LAYER_TYPE_UID_PREFIX_FORECASTS}index`,
    isAdBlock: false,
    isLocked: false,
    paywallType: DATA_LAYER_TYPE_PAYWALL__NONE,
    section: DATA_LAYER_TYPE_SECTION__FORECASTS,
    accessType: DATA_LAYER_TYPE_ACCESS_TYPE__PUB,
    userSubscriptionTier,
  };

  return dataLayerProps;
};

export const getDataLayerPropsForNotFoundPage = (userSubscriptionTier: string): DataLayerProps => {
  const dataLayerProps: DataLayerProps = {
    unifiedAssetId: `${DATA_LAYER_TYPE_UID_PREFIX_FORECASTS}-not-found`,
    isAdBlock: false,
    isLocked: false,
    paywallType: DATA_LAYER_TYPE_PAYWALL__NONE,
    section: DATA_LAYER_TYPE_SECTION__FORECASTS,
    accessType: DATA_LAYER_TYPE_ACCESS_TYPE__PUB,
    userSubscriptionTier,
  };

  return dataLayerProps;
};
